import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { EditBankDetailsComponent } from '../edit-bank-details/edit-bank-details.component';
import { EditCompanyDetailsComponent } from '../edit-company-details/edit-company-details.component';
import { EditDirectorDetailsComponent } from '../edit-director-details/edit-director-details.component';
import { EditDocumentsComponent } from '../edit-documents/edit-documents.component';
import { EditSignatoryDetailsComponent } from '../edit-signatory-details/edit-signatory-details.component';
import { CorporateData, CorporateAccountkyc, CorporateAccountbankInfo, CorporateDirector, CorporateDoc } from '@core/models/admin/account';
import { CorporateRegistrationService, GetAccountSignatoriesData } from '@core/services/corporate-registration.service';
import { Observable, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ActivatedRoute } from '@angular/router';
import { AccountManagementService } from '@core/services/account-management.service';
import { NotificationFacade } from '@core/facades/notification.facade';
import { BreadCrumbService } from '@core/services/bread-crumb.service';

@Component({
  selector: 'app-edit-details',
  standalone: true,
  imports: [
    EditCompanyDetailsComponent,
    EditBankDetailsComponent,
    EditDirectorDetailsComponent,
    EditSignatoryDetailsComponent,
    EditSignatoryDetailsComponent,
    EditDocumentsComponent,
    CommonModule,
    NgxSkeletonLoaderModule
  ],
  templateUrl: './edit-details.component.html',
  styleUrl: './edit-details.component.scss'
})
export class EditCorporateDetailsComponent {
  isLoading$!: Observable<boolean>;
  corporateAccountData!: CorporateData;
  companyDetails!: CorporateAccountkyc;
  bankDetails!: CorporateAccountbankInfo[];
  directorDetails!: CorporateDirector[] | null;
  signatoriesList: GetAccountSignatoriesData[] = [];
  documents!: CorporateDoc[];
  subs: Subscription[] = [];
  accountId!: string;

    isFetchingSignatories$!: Observable<boolean>;
  isFetchingCompanyDetails$!: Observable<boolean>;

  route = inject(ActivatedRoute);
    private accountService = inject(AccountManagementService);
    cdr = inject(ChangeDetectorRef);
    toast = inject(NotificationFacade);
    corporateService = inject(CorporateRegistrationService);
    breadCrumbService = inject(BreadCrumbService);

      ngOnInit(): void {
    this.accountId = this.route.snapshot.parent?.params['accountId'];
    this.breadCrumbService.setPageBreadCrumb(this.route);

    if (this.accountId) {
      this.getCompanyDetails();
      this.getAccountSignatories();
    }
  }

    getCompanyDetails() {
    const subs = this.accountService
      .getCorporateAccountInfo(this.accountId)
      .subscribe({
        next: (response) => {
          this.corporateAccountData = response.data;
          this.companyDetails = this.corporateAccountData.account_kyc;
          this.bankDetails =
            this.corporateAccountData.account_kyc.account_bank_info;
          this.directorDetails = this.corporateAccountData.director;
          this.documents = this.corporateAccountData.account_kyc.doc;
          this.cdr.detectChanges();
        },  
        error: (err) => {},
      });
    this.subs.push(subs);
  }

  getAccountSignatories(): void {
    const sub = this.corporateService
      .getAccountSignatories(this.accountId)
      .subscribe({
        next: (response) => {
          this.signatoriesList = response.data;
          this.cdr.detectChanges();
        },
        error: (response) => {
          this.toast.error('Failed to fetch signatories');
        },
      });

    this.subs.push(sub);
  }
}
